export { default } from './InfoBubbleLower'
